// extracted by mini-css-extract-plugin
export default {"container":"OwnerField_container__OJ6Il","avatar":"OwnerField_avatar__Vo0FQ"};